<template>
<m-pageframe
    title="{organization_label}: Analytics"
>
<v-container>

     <template v-for="(item, index) in pages">
        <!-- Regular item -->
        <v-list-item
            v-if="!item.admin_only"
            :key="index"
            v-on:click="onClickPage(item)"
        >
            <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon><v-icon>mdi-arrow-right</v-icon></v-list-item-icon>
        </v-list-item>

        <!-- Admin-only item -->
        <m-restricted-menu-list-item
            v-else-if="$rc.$state.isAuthActorSystemAdmin()"
            :key="'admin-'+index"
            v-on:click="$rc.$state.isAuthActorSystemAdmin() ? onClickPage(item) : null"
            
            :text="item.title"
            :icon="item.icon"
        >
            <v-list-item-icon><v-icon>mdi-arrow-right</v-icon></v-list-item-icon>
        </m-restricted-menu-list-item>
    </template>



</v-container>
</m-pageframe>
</template>

<script>
export default {
    methods: {
        onClickPage(page) {
            if ( page.on_click != null )
            {
                page.on_click();
                return;
            }

            this.$router.push({
                'name': page.page,
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                },
                'query': page.query
            });
        },

        doExportOptIns()
        {
            this.$rc.excelExport(
                    'EXPORT: /api/v1/bulk/opt-outs/export-current-state/:organization_id',
                    {
                        'organization_id' : this.$route.params.organization_id,
                    }
                );
        },
    },
    computed: {
        pages() {
            let ret = [];
            ret.push({'icon': 'mdi-chat-outline', 'title':'Web Chat Requests', 'page': 'analytics-web-chat', 'admin_only': false});
            ret.push({'icon': 'mdi-comment-text-multiple', 'title':'All Bulk Messages', 'page': 'analytics-all-bulk-messages', 'admin_only': false});
            ret.push({'icon': 'mdi-clipboard-check-outline', 'title':'Guest Check-In Analytics', 'page': 'guest-check-in-analytics', 'admin_only': false});
            ret.push({'icon': 'mdi-package-variant-closed-check', 'title': 'Bulk Messages: Club Customization', 'page': 'analytics-all-club-customization', 'admin_only': true});
            ret.push({'icon': 'mdi-check-underline', 'title': 'Opt-ins', 'on_click': () => this.doExportOptIns(), 'admin_only': false});
            ret.push({'icon': 'mdi-check-underline', 'title': 'Opt-ins (new layout demo)', 'page': 'analytics-opt-in', 'admin_only': true});
            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>